"use client";

import React from "react";
import Icon from "@/components/frontend/ui/icon";
import { ResponsiveContainer } from "@/components/frontend/layout/header/responsive-container";
import { useMobileMenu } from "@/contexts/frontend/mobile-menu-context";
import type { NavbarMobileMenuToggle as NavbarMobileMenuToggleT } from "@/payload-types";

export const NavbarMobileMenuToggle: React.FC<NavbarMobileMenuToggleT> = (props) => {
	const ctx = useMobileMenu();
	const mobileOpen = ctx?.mobileOpen ?? false;
	const setMobileOpen = ctx?.setMobileOpen;

	if (!setMobileOpen) {
		return null;
	}

	return (
		<ResponsiveContainer block={props} barPrefix="navbar">
			<button type="button" aria-label="Toggle menu" aria-expanded={mobileOpen} onClick={() => setMobileOpen((open) => !open)}>
				<Icon name={mobileOpen ? "X" : "Menu"} className="size-6" />
			</button>
		</ResponsiveContainer>
	);
};
